<template>
  <div class="sid-CategoryButton">
    <div class="sw-SquareBox">
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
    </div>
    <TextLink
      class="sid-CategoryButtonLink"
      content="すべてのカテゴリーを見る"
      href="/categories"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import { TextLink } from '@raksul/raksul-common-ui'
export default Vue.extend({
  name: 'CategoryButton',
 components: {
    TextLink
  }
})
</script>
